var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorYtube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4571 9.16736e-08C16.9185 -0.000145901 17.3628 0.174086 17.7011 0.487769C18.0393 0.801451 18.2465 1.2314 18.2811 1.69143L18.2857 1.82857V12.8C18.2859 13.2613 18.1116 13.7057 17.798 14.0439C17.4843 14.3822 17.0543 14.5894 16.5943 14.624L16.4571 14.6286H1.82857C1.36724 14.6287 0.922911 14.4545 0.584642 14.1408C0.246373 13.8271 0.0391711 13.3972 0.00457163 12.9371L9.16736e-08 12.8V1.82857C-0.000145901 1.36724 0.174086 0.92291 0.487769 0.584642C0.801452 0.246373 1.2314 0.0391711 1.69143 0.00457162L1.82857 9.16736e-08H16.4571ZM16.4571 3.12137L10.112 9.46651C9.85486 9.72334 9.50629 9.86759 9.14286 9.86759C8.77943 9.86759 8.43086 9.72334 8.17372 9.46651L1.82857 3.12137V12.8H16.4571V3.12137ZM15.1643 1.82857H3.12137L9.14286 7.85006L15.1643 1.82857Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorYtube);
export default __webpack_public_path__ + "static/media/VectorYtube.b8f369e5b4417aaf5369f49a6d25935c.svg";
export { ForwardRef as ReactComponent };